import _ from 'lodash';
import waffle from './PDFWaffleChart';
import dotPlotBullet from './PDFDotPlotBullet';
import defaultChart from './PDFBaseChart';
import deprivationChart from './PDFDeprivationChart';
import populationPyramid from './PDFPopulationPyramid';
import populationGrowth from './PDFPopulationGrowth';
import multiDotPlotBullet from './PDFMultiDotPlotBullet';
import rankedBar from './PDFRankedBar';
import regionCompareDotPlot from './PDFRegionCompareDotPlot';
import chartContainerTemplate from './PDFChartContainerTemplate';
import references from './PDFReferences';

const chartConstructors = {
    waffle,
    dotPlot: dotPlotBullet,
    bulletChart: dotPlotBullet,
    populationPyramid,
    populationGrowth,
    multiBulletChart: multiDotPlotBullet,
    multiDotPlot: multiDotPlotBullet,
    deprivation: deprivationChart,
    deprivation_type: deprivationChart,
    rankedBar,
    regionCompareDotPlot
};

// function excludedMetric(metric) {
//     return {
//         font: { colour: '#000000' },
//         excludedText: {
//             text: 'In this custom report, the user has chosen to exclude:'
//         },
//         label: {
//             font: { style: 'italic' },
//             text: `${metric.pdfLabel}`
//         }
//     };
// }

const excludedMetricsMsg = () => ({
    font: { weight: 'bold' },
    excludedText: {
        text: 'In this custom report, the user has chosen to exclude one or more metrics.  More metrics are available for the topic at http://healthiertogether.ca/profiles'
    }
});

function groupIntoColumns(printMetrics, metricsPerCol) {
    let i = 0;
    const columnedMetrics = _.groupBy(printMetrics, (m) => m.position || `col-${i++ < metricsPerCol ? 1 : 2}`);
    return columnedMetrics;
}

export function metricChartFactory(options) {
    return (metric) => {
        if (!metric.print) {
            return null;
            // This is old, but may be needed again.
            // Inserts a message in place of the metric, instead of at the end.
            // Uncomment here and the excludedMetric function above.
            // return excludedMetric(metric);
        }
        // eslint-disable-next-line no-param-reassign
        metric.reference = references.add(metric.dataSource);
        const chartContainer = chartContainerTemplate(metric, options);
        const chartConstructor = chartConstructors[metric.chartType] || defaultChart;
        const metricChart = chartConstructor(metric, chartContainer);
        // Metric can override default chart container heights and margins.
        metricChart.h = metric.h || metricChart.h; // Default height is calculated/flows
        metricChart.mt = metric.mt || metricChart.mt;
        metricChart.mb = metric.mb || metricChart.mb || 'h-0-1/4';
        return metricChart;
    };
}

export function createCharts(printMetrics, { colour = '#111111', metricsPerCol, mt = 20 } = {}) {
    const numMetrics = Object.keys(printMetrics).length;
    // eslint-disable-next-line no-param-reassign
    metricsPerCol = metricsPerCol || numMetrics / 2;
    // Group by position
    const metricsByPos = groupIntoColumns(printMetrics, metricsPerCol);
    const col1 = {
        w: 'w-col',
        ..._.mapValues(metricsByPos['col-1'], metricChartFactory({ colour }))
    };
    const col2 = {
        w: 'w-col',
        ml: 'gutter',
        display: 'inline',
        ..._.mapValues(metricsByPos['col-2'], metricChartFactory({ colour }))
    };
    if (_.findKey(metricsByPos['col-1'], { print: false })) {
        col1.excludedMetricsMsg = excludedMetricsMsg();
    } else if (_.findKey(metricsByPos['col-2'], { print: false })) {
        col2.excludedMetricsMsg = excludedMetricsMsg();
    }
    // TODO: mt is only needed because the single page category sections are not flowing with the category pages.
    const chartContainer = {
        mt,
        // border: { colour: '#ff0000' },
        // text: 'Charts here',
        col1,
        col2
    };
    return chartContainer;
}

export default ({ printMetrics, colorClass = 'print.primary.7' }, options = {}) => {
    if (printMetrics) {
        return {
            ...createCharts(printMetrics, { colour: colorClass, ...options })
        };
    }
    return null;
};
